const SCHEME = /^[a-z][a-z\d+.-]*:/i;

function isExternalOrAnchor(path) {
  return path.startsWith("#") || path.startsWith("//") || SCHEME.test(path);
}

function localizeSearch(search, lang) {
  const params = new URLSearchParams(search);

  if (lang === "en") {
    params.set("lang", "en");
  } else {
    params.delete("lang");
  }

  const result = params.toString();
  return result ? `?${result}` : "";
}

export function buildLocalizedPath(to, lang) {
  if (typeof to === "string") {
    if (isExternalOrAnchor(to)) return to;

    const hashIndex = to.indexOf("#");
    const hash = hashIndex === -1 ? "" : to.slice(hashIndex);
    const pathAndSearch = hashIndex === -1 ? to : to.slice(0, hashIndex);
    const searchIndex = pathAndSearch.indexOf("?");
    const path = searchIndex === -1 ? pathAndSearch : pathAndSearch.slice(0, searchIndex);
    const search = searchIndex === -1 ? "" : pathAndSearch.slice(searchIndex);

    return `${path}${localizeSearch(search, lang)}${hash}`;
  }

  if (to && typeof to === "object") {
    const pathname = to.pathname || "";
    if (isExternalOrAnchor(pathname) || (!pathname && !to.search && to.hash)) return to;

    return { ...to, search: localizeSearch(to.search || "", lang) };
  }

  return to;
}
